import apiSales from 'services/apiSales';
import { ParamsBrands, ParamsModels, ParamsVersions, ParamsYear, ParamsColors } from 'utils/typeServices';

type ParamsResponseBrands = {
    Data: Array<ParamsBrands>;
}

type ParamsResponseModels = {
    Data: Array<ParamsModels>;
}

type ParamsResponseVersions = {
    Data: Array<ParamsVersions>;
}

type ParamsResponseYear = {
    Data: Array<ParamsYear>;
}

type ParamsResponseColors = {
    Data: Array<ParamsColors>;
}

export const getBrands = async (token: string) => {
    try {
        const { data } = await apiSales.get<ParamsResponseBrands>('vehicle/brands', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { DtBrands: data.Data };

    } catch (error) {
        return { DtBrands: null };
    }
}

export const getModels = async (CD_MARCA: number, token: string) => {
    try {
        const { data } = await apiSales.get<ParamsResponseModels>('vehicle/models', {
            headers: {
                'Authorization': 'Bearer ' + token,
                'CD_MARCA': `${CD_MARCA}`
            }
        });

        return { DtModels: data.Data };

    } catch (error) {
        return { DtModels: null };
    }
}

export const getVersions = async (CD_MODELO_BASICO: number, token: string) => {
    try {
        const { data } = await apiSales.get<ParamsResponseVersions>('vehicle/versions', {
            headers: {
                'Authorization': 'Bearer ' + token,
                'CD_MODELO_BASICO': `${CD_MODELO_BASICO}`
            }
        });

        return { DtVersions: data.Data };

    } catch (error) {
        return { DtVersions: null };
    }
}

export const getYear = async (CD_MODELO: number, token: string) => {
    try {
        const { data } = await apiSales.get<ParamsResponseYear>('vehicle/years', {
            headers: {
                'Authorization': 'Bearer ' + token,
                'CD_MODELO': `${CD_MODELO}`
            }
        });

        return { DtYear: data.Data };

    } catch (error) {
        return { DtYear: null };
    }
}

export const getColors = async (token: string) => {
    try {
        const { data } = await apiSales.get<ParamsResponseColors>('vehicle/colors', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { DtColors: data.Data };

    } catch (error) {
        return { DtColors: null };
    }
}
